// Gated Content

window.SiteReady(($) => {
  console.log('Init: Gated Content');

  function checkGatedContent() {
    let gated_id = $('.js-gated_target').data('gated-id');

    $.ajax({
      url: THEME_OPTIONS.ajax_url,
      type: 'get',
      data: {
        action: 'check_gated_content',
        gated_id: gated_id,
        cache: true,
      },
      success: function(response, status, jqXHR) {
        if (response === 'false') {
          $('.js-gated_target').addClass('locked');
        } else {
          $('.js-gated_target').addClass('unlocked');
        }

        $('.js-gated_target').addClass('ready');
      },
      error: function() {
        console.log(arguments);
      }
    });
  }

  if ($('.js-gated_target').length) {
    checkGatedContent();

    $(document).on('gform_confirmation_loaded', function(e, formId) {
      checkGatedContent();
    });
  }

});